"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css");

var _reactModernCalendarDatepicker = _interopRequireDefault(require("@hassanmojab/react-modern-calendar-datepicker"));

var _Icons = require("../../atoms/Icons");

var _molecules = require("../../molecules");

var _DatePickerModule = _interopRequireDefault(require("./DatePicker.module.css"));

var _constants = require("./constants");

var _excluded = ["placeholder", "onBlur", "onChange", "minimumDate", "maximumDate"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DatePickerInput = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var placeholder = props.placeholder,
      onBlur = props.onBlur,
      onChange = props.onChange,
      minimumDate = props.minimumDate,
      maximumDate = props.maximumDate,
      rest = _objectWithoutProperties(props, _excluded);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      selectedDate = _useState2[0],
      setSelectedDate = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = _slicedToArray(_useState3, 2),
      inputValue = _useState4[0],
      setInputValue = _useState4[1];

  var _useState5 = (0, _react.useState)(_constants.DAY_LABEL),
      _useState6 = _slicedToArray(_useState5, 2),
      daySelected = _useState6[0],
      setDaySelected = _useState6[1];

  var _useState7 = (0, _react.useState)(_constants.MONTH_LABEL),
      _useState8 = _slicedToArray(_useState7, 2),
      monthSelected = _useState8[0],
      setMonthSelected = _useState8[1];

  var _useState9 = (0, _react.useState)(_constants.YEAR_LABEL),
      _useState10 = _slicedToArray(_useState9, 2),
      yearSelected = _useState10[0],
      setYearSelected = _useState10[1];

  var handleBlur = (0, _react.useCallback)(function (e) {
    e.preventDefault();
    if (onBlur) onBlur(e);
  }, []);
  var handleKeyDown = (0, _react.useCallback)(function (event) {
    event.preventDefault();
  }, []);
  var handleChange = (0, _react.useCallback)(function (evt) {
    setSelectedDate(evt);

    if (onChange) {
      var realMonth = evt.month >= 10 ? evt.month : "0".concat(evt.month);
      var realDay = evt.day >= 10 ? evt.day : "0".concat(evt.day);
      var event = {
        target: {
          value: "".concat(evt.year, "-").concat(realMonth, "-").concat(realDay)
        }
      };
      onChange(event);
    }
  }, [setSelectedDate]);
  (0, _react.useEffect)(function () {
    if (!selectedDate) return;
    var day = selectedDate.day,
        month = selectedDate.month,
        year = selectedDate.year;
    setDaySelected(day);
    setMonthSelected(month - 1);
    setYearSelected(year);
    var allValidDates = day && month && year;

    if (allValidDates) {
      var noValues = daySelected === _constants.DAY_LABEL && monthSelected === _constants.MONTH_LABEL && yearSelected === _constants.YEAR_LABEL;
      var dayFormatted = daySelected === _constants.DAY_LABEL || daySelected >= 10 ? daySelected : "0".concat(daySelected);
      var monthFormatted = _constants.months[monthSelected] || _constants.MONTH_LABEL;
      var finalValue = noValues ? '' : "".concat(dayFormatted, " / ").concat(monthFormatted, " / ").concat(yearSelected);
      setInputValue(finalValue);
    }
  }, [selectedDate, daySelected, monthSelected, yearSelected]);

  var input = function input(_ref) {
    var innerRef = _ref.ref;
    return /*#__PURE__*/_react.default.createElement(_molecules.IconInput, _extends({
      ref: innerRef,
      onBlur: handleBlur,
      onKeyDown: handleKeyDown,
      icon: _Icons.Calendar,
      value: inputValue,
      placeholder: placeholder,
      readOnly: true
    }, rest));
  };

  return /*#__PURE__*/_react.default.createElement(_reactModernCalendarDatepicker.default, {
    value: selectedDate,
    onChange: handleChange,
    shouldHighlightWeekends: true,
    renderInput: input,
    colorPrimary: "007aff",
    calendarClassName: "".concat(_DatePickerModule.default.calendar, " shadow-base"),
    calendarTodayClassName: "text-default-blue",
    calendarSelectedDayClassName: "rounded-1 bg-default-blue",
    wrapperClassName: "w-full z-10",
    locale: _constants.spanishLocale,
    minimumDate: minimumDate,
    maximumDate: maximumDate,
    ref: ref
  });
});

DatePickerInput.propTypes = {
  placeholder: _propTypes.default.string,
  onBlur: _propTypes.default.func,
  onChange: _propTypes.default.func,
  minimumDate: _propTypes.default.object,
  maximumDate: _propTypes.default.object
};
var _default = DatePickerInput;
exports.default = _default;